export default __webpack_public_path__ + "static/media/g-gurjieff.8d46f4f0.jpg";